/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";

import ProtocolExtraction from "../ImportSoA/ImportProtocol.vue";

export default {
  name: "SoAExtraction",
  components: {
    VPagination,
    ProtocolExtraction,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: store.getters.getIdToken,
      head: {},
      defaultdate: localStorage.getItem("dateformat"),
      extractiondataLoading: false,
      allextractiondata: [],
      extractionCurrentPage: 1,
      extractionPageSize: 12,
      extractionTotalPages: 1,
      extractionTotalCount: 0,
      downloadingExtractionDocument: "",
      protocolextractionpopup: false,
    };
  },
  async mounted() {
    this.token = store.getters.getIdToken;
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    };
    this.defaultdate = localStorage.getItem("dateformat");
    await this.getallextractiondata();
  },
  methods: {
    async getallextractiondata(pageNumber = this.extractionCurrentPage) {
      this.extractiondataLoading = true;
      this.extractionCurrentPage = pageNumber;
      try {
        const { data } = await axios.get(
          `${this.baseurl}/management/extraction/getall?PageSize=${this.extractionPageSize}&PageNumber=${pageNumber}&IsDescending=${true}`,
          this.head
        );
        const rows = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.results)
            ? data.results
            : Array.isArray(data)
              ? data
              : [];
        const totalCount =
          data?.count !== undefined && data?.count !== null
            ? data.count
            : data?.totalCount !== undefined && data?.totalCount !== null
              ? data.totalCount
              : rows.length;
        this.allextractiondata = rows;
        this.extractionTotalCount = totalCount;
        this.extractionTotalPages = Math.max(
          1,
          Math.ceil(totalCount / this.extractionPageSize)
        );
      } catch (err) {
        console.log("error in extraction data list", err?.response?.data || err);
        this.allextractiondata = [];
        this.extractionTotalCount = 0;
        this.extractionTotalPages = 1;
      } finally {
        this.extractiondataLoading = false;
      }
    },
    async loadExtractionData(page) {
      await this.getallextractiondata(page);
    },
    getExtractionDownloadConfig(type) {
      return {
        ctq: {
          statusKey: "ctqStatus",
          documentIdKey: "ctqDocumentId",
        },
        soa: {
          statusKey: "soaStatus",
          documentIdKey: "soaDocumentId",
        },
        editCheck: {
          statusKey: "editCheckStatus",
          documentIdKey: "editCheckDocumentId",
        },
        ecrf: {
          statusKey: "ecrfStatus",
          documentIdKey: "ecrfDocumentId",
        },
      }[type];
    },
    isExtractionCompleted(status) {
      return String(status || "").toLowerCase() === "completed";
    },
    isExtractionDownloadReady(item, type) {
      const config = this.getExtractionDownloadConfig(type);
      return (
        !!config &&
        this.isExtractionCompleted(item?.[config.statusKey]) &&
        !!item?.[config.documentIdKey]
      );
    },
    isExtractionDownloadLoading(item, type) {
      return this.downloadingExtractionDocument === `${item?.auditId}-${type}`;
    },
    formatExtractionStatus(status) {
      return status || "-";
    },
    getExtractionDownloadFileName(response, fallbackName) {
      const disposition =
        response?.headers?.["content-disposition"] ||
        response?.headers?.["Content-Disposition"] ||
        "";
      const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
      if (utf8Match) {
        return decodeURIComponent(utf8Match[1]);
      }
      const quotedMatch = /filename="([^"]+)"/i.exec(disposition);
      if (quotedMatch) {
        return decodeURIComponent(quotedMatch[1]);
      }
      const unquotedMatch = /filename=([^;]+)/i.exec(disposition);
      if (unquotedMatch) {
        return decodeURIComponent(unquotedMatch[1].trim());
      }
      // const matchedName =
      //   /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disposition);
      // if (matchedName) {
      //   return decodeURIComponent(matchedName[1] || matchedName[2] || "");
      // }
      return fallbackName;
    },
    getExtractionDocumentExtension(contentType = "") {
      if (/zip/i.test(contentType)) return ".zip";
      if (/pdf/i.test(contentType)) return ".pdf";
      if (/spreadsheetml|excel/i.test(contentType)) return ".xlsx";
      if (/csv/i.test(contentType)) return ".csv";
      if (/json/i.test(contentType)) return ".json";
      if (/plain/i.test(contentType)) return ".txt";
      return ".bin";
    },
    getSafeExtractionBaseName(item, label) {
      const protocolName = item?.protocolName || "extraction";
      return `${protocolName}_${label}`
        .replace(/\s+/g, "_")
        .replace(/[\\/:*?"<>|]/g, "");
    },
    async downloadExtractionDocument(documentId, label, item) {
      if (!documentId) {
        alert("Document is not available for download.");
        return;
      }
      const type = label === "Edit Check" ? "editCheck" : label.toLowerCase();
      this.downloadingExtractionDocument = `${item?.auditId}-${type}`;
      try {
        const response = await axios.get(
          `${this.baseurl}/etmf/document/getdocument?documentId=${encodeURIComponent(documentId)}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              Accept: "*/*",
            },
            responseType: "blob",
          }
        );
        const contentType =
          response?.headers?.["content-type"] || "application/octet-stream";
        const fallbackName = `${this.getSafeExtractionBaseName(item, label)}${this.getExtractionDocumentExtension(contentType)}`;
        const fileName = this.getExtractionDownloadFileName(response, fallbackName);
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.log("error downloading extraction document", err?.response?.data || err);
        alert("Document download failed");
      } finally {
        this.downloadingExtractionDocument = "";
      }
    },
    protocolextraction() {
      this.protocolextractionpopup = true;
    },
    colseprotocolextractinmodel() {
      this.protocolextractionpopup = false;
      this.getallextractiondata(1);
    },
    filterDate(date) {
      if (date) {
        return moment(date).format(this.defaultdate);
      }
      return null;
    },
    goToViewProtocol(id) {
      this.$router.push({path: `/StudyProtocolMng`,query: { id }});
    },
  },
};
